<template>
	<div class="signup-form">

			<v-container fluid fill-height>
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md4 lg4>
						<v-card class="pa-4" outlined>
							<v-card-text>
								<div class="layout column align-center">
									
									<h2 class="flex my-8 font-weight-light">
										Set you first market
									</h2>
									<p class="text-center">
									Following information will be used as default value for your dashboard.
									</p>
								</div>
								<v-form
								ref="add_market_form"
								lazy-validation
								>
									<v-text-field
										
										outlined
										name="market_name"
										label="Market Name"
										type="text"
										v-model="market_name"
										:error="error"
										:rules="market_name_rules"

									/>

									<v-autocomplete
									v-model="seleted_area"
									:items="bahrain_area"
									item-text="name_en"
									item-value="object_id"
									label="Select Area"
									
									outlined
									:error="error"
									:rules="seleted_area_rules"
									></v-autocomplete>
									<v-autocomplete
						
									outlined
									v-model="selected_activity"
									:items="business_activity_list"
									label="Select Business Activity"
									item-text="name_en"
									item-value="object_id"
									clearable
									:error="error"
									:rules="selected_activity_rules"
									></v-autocomplete>
									
									

								</v-form>
							</v-card-text>
							<div class="px-4 font-weight-light body-2">
								
								
								<v-btn
									large
									block

									color="teal white--text"
									:loading="loading"
									@click="add_market"
									>Continue</v-btn
								>
							</div>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
	

		

		<v-snackbar
			v-model="error_snackbar"
			bottom
			color="error"
			outlined
			right>
			{{ snackbar_error_message }}

		<template v-slot:action="{ attrs }">
			<v-btn
				color="pink"
				text

				v-bind="attrs"
				@click="error_snackbar = false"
				>
				Close
			</v-btn>
		</template>
		</v-snackbar>


		<v-snackbar
			:timeout="2000"
			
			bottom
			color="success"
			outlined
			right
			v-model="success_snakbar">
			{{ snackbar_success_message }}

		<template v-slot:action="{ attrs }">
			<v-btn
				color="teal"
				text

				v-bind="attrs"
				@click="success_snakbar = false"
				>
				Close
			</v-btn>
		</template>
	</v-snackbar>
	</div>

</template>

<script>
import business_json from '@/data/business_activity_list.json'
import bahrain_area_block from '@/data/bahrain_area_block.json'
import { add_market} from '@/api/app'
export default {
	name:'AddMarket',
	data() {

		return {
			seleted_area:'',
			selected_activity:'',
			seleted_area_rules:[v => !!v || 'Area is required',],
			selected_activity_rules:[v => !!v || 'Activity is required',],
			market_name_rules:[
				v => !!v || 'Market name is required',
				v => v.trim().length<30 || 'Market name is too long',
				v => v.trim().length>2 || 'Market name is too short',
				],
			
			error_snackbar: false,
			success_snakbar:false,
			snackbar_error_message:"",
			snackbar_success_message:"",
			business_activity_list:business_json,
			bahrain_area:bahrain_area_block,

			loading: false,
			market_name: "",
			
			
			error: false,
		
		};
	},

	methods: {
		add_market() {
			//this.verify_object_id="something";

			if (this.$refs.add_market_form.validate() ==false){

				this.snackbar_error_message = "Please fill required information";
				this.error_snackbar = true;
				return 
			}
			// do signup
			let market={
			"name":this.market_name,
			"area_object_id":this.seleted_area,
			"activity_object_id":this.selected_activity,
			
			}
			this.loading=true;
			add_market(market).then(response => {
				this.loading=false;
				if (response.error==false){
					response.data.default=false;
					this.$store.commit('add_market',response.data)
					this.snackbar_success_message=this.market_name +" is added";
					this.success_snakbar=true;
					this.$router.replace({ name: 'Dashboard' });
				}else{
					//show error
					this.snackbar_error_message=response.error_message;
					this.error_snackbar=true;
				}
			})
				//vm.$router.push({ name: "Dashboard" });
		},
		
	}
};
</script>

<style scoped lang="css">
.signup-form{
	margin-top: 48px;
	
}
</style>
